import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LazyloadDirective } from './lazyload.directive';

@NgModule({
  declarations: [LazyloadDirective],
  imports: [
    CommonModule
  ],
  exports: [LazyloadDirective]
})
export class LazyLoadModule { }
